import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatJobPositionBIModel } from 'src/app/model/cat-job-position-bi.model';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { CatJobPositionBiService } from 'src/oldApp/services/cat-job-position-bi.service';

@Component({
  selector: 'app-modal-job-position-bi',
  templateUrl: './modal-job-position-bi.component.html',
  styleUrls: ['./modal-job-position-bi.component.css']
})
export class ModalJobPositionBiComponent implements OnInit {
  @Input() position:CatJobPositionBIModel;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public viewStatus:number=1;

  // catalogos
  public employeeJobCatalog:CatEmployeeJobModel[];

  // marcaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ<>=,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  ////////////////
  constructor(
    private modalService: NgbModal,
    private catJobBIService:CatJobPositionBiService,
    private employeeJobService:CatEmployeeJobService,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  toggleActive=()=> this.position.activeId=!this.position.activeId;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.descriptionError()) errors.push('Necesita capturar una descripción.');
    if(this.employeeJobError()) errors.push('Necesita seleccionar un puesto.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.position.description=this.position.description.toUpperCase();
      this.catJobBIService.save(this.position)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('El puesto se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar el puesto.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  descriptionError=()=> !this.position.description || this.position.description.trim()==='';
  employeeJobError=()=> !this.position.jobPositionId;

  // INFO
  getCatalogs=()=> {
    this.employeeJobService.getAll()
      .pipe(
        tap((resp:any)=> {
          if(resp) this.employeeJobCatalog=resp.data;
          else throwError;
        }),
        catchError(error=> {
          console.log(error);
          this.close;
          return of(this.toastr.error('Ocurrió un error al buscar catálogos.'));
        })
      )
      .subscribe();
  }
}
